/**
 * Grows the bars of every .r2o-chart once it is well into view. Without
 * JavaScript or with reduced motion the bars are simply drawn at full height.
 */
import '../css/market-chart.css';

const WAITING_CLASS = 'r2o-chart-waiting';

if ( ! window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
	const observer = new window.IntersectionObserver(
		( entries ) => {
			for ( const { isIntersecting, target } of entries ) {
				if ( isIntersecting ) {
					target.classList.remove( WAITING_CLASS );
					observer.unobserve( target );
				}
			}
		},
		{ threshold: 0.5 }
	);

	document.querySelectorAll( '.r2o-chart' ).forEach( ( chart ) => {
		chart.classList.add( WAITING_CLASS );
		observer.observe( chart );
	} );
}
